import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home/Home.vue';
import AuthError from '../views/AuthError.vue';
import Sets from '../views/Sets/Sets.vue';
import Products from '../views/Products/Products.vue';
import PaymentConfirmed from '../views/PaymentConfirmed/PaymentConfirmed.vue';
import { ErrorHandler, NavigationFailure, RawLocation, Route } from 'vue-router/types/router';

// Rewrite Router push method to prevent throwing errors when navigating to the route we are already in which throws an error like:
//  "NavigationDuplicated: Navigating to current location ("/sets") is not allowed"
const originalPush = VueRouter.prototype.push;
(VueRouter.prototype.push as (
    location: RawLocation,
    onComplete?: Function,
    onAbort?: ErrorHandler
) => void | Promise<Route | NavigationFailure>) = function push(
    this: any,
    location: RawLocation,
    onResolve?: Function,
    onReject?: ErrorHandler
) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }

    return (originalPush as (location: RawLocation) => Promise<Route>).call(this, location).catch((error) => {
        if (VueRouter.isNavigationFailure(error)) {
            // resolve error
            return error;
        }

        // rethrow error
        return Promise.reject(error);
    });
};

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/shPaymentConfirmed/:storeUrl',
        name: 'Shopify Payment Confirmed',
        component: PaymentConfirmed,
        meta: {
            isOpen: true
        }
    },
    {
        path: '/authError',
        name: 'Authentication Error',
        component: AuthError
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings/Settings.vue')
    },
    {
        path: '/sets',
        name: 'Sets',
        component: Sets,
        beforeEnter: (to, from, next) => {
            // Preload set page
            import(/* webpackChunkName: "sets" */ '../views/Set/Set.vue');
            next();
        }
    },
    {
        path: '/set',
        name: 'Set',
        component: () => import(/* webpackChunkName: "sets" */ '../views/Set/Set.vue')
    },
    {
        path: '/products',
        name: 'Products',
        component: Products,
        beforeEnter: (to, from, next) => {
            // Preload product page
            import(/* webpackChunkName: "products" */ '../views/Product/Product.vue');
            next();
        }
    },
    {
        path: '/product',
        name: 'Product',
        component: () => import(/* webpackChunkName: "products" */ '../views/Product/Product.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
});

export default router;
